import { CartPage } from '../../src/screens/CartPage';

export default CartPage;
